/**
 * Status dot indicator component.
 *
 * Used for showing health status (healthy, degraded, down).
 *
 * Implementation plan reference: D2.16
 */

interface DotProps {
  status: 'healthy' | 'degraded' | 'down' | 'unknown';
}

export function Dot({ status }: DotProps): JSX.Element {
  return (
    <span className={`dot dot-${status}`} aria-label={status} />
  );
}
